import React from 'react';
import PropTypes from 'prop-types';

/**
 * A reusable component for displaying the End User License Agreement.
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Eula = _ref => {
  let {
    title = 'End User License Agreement',
    sections,
    openLink = url => typeof window !== 'undefined' ? window.open(url, '_blank') : () => {},
    className = ''
  } = _ref;
  return /*#__PURE__*/_jsxs("div", {
    className: "pt-5 flex flex-col",
    children: [/*#__PURE__*/_jsx("header", {
      children: /*#__PURE__*/_jsx("h2", {
        className: "pb-3 text-center font-bold",
        children: title
      })
    }), sections && sections.length > 0 && /*#__PURE__*/_jsx("div", {
      className: "p-5 overflow-y-auto mb-10 border border-light-border-blue rounded",
      style: {
        maxHeight: '400px'
      },
      children: sections.map((section, index) => /*#__PURE__*/_jsxs("section", {
        children: [section.header && /*#__PURE__*/_jsx("h3", {
          className: "pb-3 uppercase underline heavy-font",
          children: section.header
        }), section.subSections && section.subSections.map((subSection, subIndex) => /*#__PURE__*/_jsxs("section", {
          children: [subSection.title && /*#__PURE__*/_jsxs("h4", {
            className: "inline font-bold text-text-blue",
            children: [subSection.title, "\xA0"]
          }), /*#__PURE__*/_jsxs("span", {
            children: [subSection.content, subSection.link && /*#__PURE__*/_jsx("a", {
              onClick: () => openLink(subSection.link.url),
              rel: "noopener noreferrer",
              role: "link",
              tabIndex: 0,
              title: subSection.link.text,
              children: subSection.link.text
            })]
          })]
        }, subIndex)), section.subContent && section.subContent.map((contentElement, contentIndex) => /*#__PURE__*/_jsxs("div", {
          children: [contentElement.title && /*#__PURE__*/_jsxs("h4", {
            className: "inline font-bold text-text-blue",
            children: [contentElement.title, "\xA0"]
          }), contentElement.content, contentElement.link && /*#__PURE__*/_jsx("a", {
            onClick: () => openLink(contentElement.link.url),
            rel: "noopener noreferrer",
            role: "link",
            tabIndex: 0,
            title: contentElement.link.text,
            children: contentElement.link.text
          })]
        }, contentIndex))]
      }, index))
    })]
  });
};
Eula.propTypes = {
  /** The title of the EULA document */
  title: PropTypes.string,
  /** Array of sections containing the EULA content */
  sections: PropTypes.arrayOf(PropTypes.shape({
    /** Section header text */
    header: PropTypes.string,
    /** Array of subsections within each main section */
    subSections: PropTypes.arrayOf(PropTypes.shape({
      /** Subsection title */
      title: PropTypes.string,
      /** Main content text */
      content: PropTypes.string.isRequired,
      /** Optional link in the subsection */
      link: PropTypes.shape({
        /** Link display text */
        text: PropTypes.string.isRequired,
        /** Link URL */
        url: PropTypes.string.isRequired
      })
    }))
  })).isRequired,
  /** Function to handle opening external links */
  openLink: PropTypes.func,
  /** Additional CSS class names */
  className: PropTypes.string
};
export default Eula;
//# sourceMappingURL=Eula.js.map